export const messageErrorInformation: { [id: string]: string } = {
  invalidUserId: "Invalid recepient",
  userBlocked: "You are not allowed to message the recipient.",
};
